/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
    headerClass: 'bg-sudance',
    app_id:'jmb0h4w4',
    loginImage: 'assets/demo/images/login/geo-login-back.jpg',
    appVersion: require('../../package.json').version,
    baseUrl: 'https://perform.geoserves-uat.com',
    reportServerUrl:'https://perform.geoserves-uat.com',
    verificationServiceUrl:'https://perform.geoserves-uat.com',
    backgroundServerUrl : 'https://perform.geoserves-uat.com',
    cpbackgroundServiceUrl :'https://perform.geoserves-uat.com',
    sensorengine: 'https://perform.geoserves-uat.com',
    name: 'GeoPerform UAT',
    production: true,
    // See environment.prod.ts — analytics report only from real production,
    // independently of Angular's `production` (prod-mode) flag above.
    enableAmplitude: false,
    apiUrl: "https://perform.geoserves-uat.com",
    // Per-service overrides for running a backend locally. Empty means "use apiUrl", which is
    // the correct value in every deployed environment - there, all services sit behind one host.
    userApiUrl: "",
    masterApiUrl: "",
    digitalTwinApiUrl: "",
    voyageApiUrl: "",
    authServerUrl: "https://perform.geoserves-uat.com",
    authServerLoginApi: "https://perform.geoserves-uat.com/api/auth/login",
    authServerLoginWithSsoApi: "https://perform.geoserves-uat.com/api/auth/login-with-sso",
    authServerLoginWithGeoOneSsoApi: "https://perform.geoserves-uat.com/api/auth/login-with-geo-one-sso",
    authServerRefreshApi: "https://perform.geoserves-uat.com/api/auth/refresh",
    authServerLogoutApi: "https://perform.geoserves-uat.com/api/auth/logout",
    SSOclientId: "6edc16de-06aa-44ba-84df-bfda051a3a6b",
    SSOAutority: "a0bdf996-65bc-49f7-9b9a-687d34df8c65",
    graphMeEndpoint: "https://graph.microsoft.com",
    microsoftLoginUrl: "https://login.microsoftonline.com",
    post_logout_redirect_uri: "https://perform.geoserves-uat.com/auth/login",
    // ETS Specific
    etsMaster: "https://perform.geoserves-uat.com/api/master",
    etsVoyage: "https://perform.geoserves-uat.com/api/voyage",
    storageApiUrl: "https://perform.geoserves-uat.com/api/voyage",
    etsRepoURL: "https://perform.geoserves-uat.com/api/ets",
    voyageoptimisation:"https://vo.geoserves-uat.com/login",
    etsBaseUrl: 'https://perform.geoserves-uat.com/api/ets',
    pulseUrl: "https://pulse.geoserves.com"
  };
